module.exports = __webpack_public_path__ + "static/img/mummy_red.2b7f212a.png";